module.exports = __webpack_public_path__ + "img/case09.13c855c7.png";